ixModuleRouting("impactx.delegation", {
    "/delegationlogin": {
        templateUrl: "modules/delegation/templates/delegationlogin.html",
        process: "Delegation",
        controller: "DelegationLoginCtrl",
        controllerAs: "delegationLoginCtrl",
    },
});
